module.exports = __webpack_public_path__ + "img/PK_Info_Game3.0ae7cd4c.png";